<template>
  <div id="content" style="font-size: 15px">
    <a href="http://www.electrochips.com" target="_blank">
      <div class="logo">
        <img src="static/img/logo.png">
      </div>
    </a>
    <label>Introduzca valores de búsqueda y presione tecla intro para mostrar resultados</label>
    <br>
    <label>Tipo</label>
    <br>
    <select disabled class="input" v-model="tipo">
      <option>DIRECCION ELECTRICA</option>
      <option v-for="(item, key) in tipos" :key="key" v-bind:value="item.id">{{item.Nombre}}</option>
    </select>
    <br>
    <!-- v-show="img!='' && img!=null" -->
    <a v-show="img" v-bind:href="getIMGRoute+img" target="_blank">
      <div class="image">
        <!-- <img v-bind:src="getIMGRoute+img" @error="this.src = 'static/img/Imagen_no_disponible.svg'"> -->
        <img v-bind:src="getIMGRoute+img" onerror="this.src = 'static/img/Imagen_no_disponible.svg'">
      </div>
    </a>
    <br>
    <label>Subtipo</label>
    <br>
    <select class="input" v-model="subtipo">
      <option value="*">Todos</option>
      <option v-for="(item, key) in subtipos" :key="key">{{item.subtipo}}</option>
    </select>
    <br>
    <br>
    <label>Vehículo</label>
    <br>
    <div v-on:click="ref='';refeq=''">
      <vue-single-select
              placeholder="Familia"
              v-model="fam"
              :options="list"
              :required="true"
              class="input"
              max-height="50vh"
              :max-results="1000"
      ></vue-single-select>
    </div>
    <br>
    <label>Referencia Fabricante/Marca</label>
    <br>
    <input class="input" type="text" v-model="ref" v-on:keyup.enter="f_ref" v-on:click="subtipo='*',fam='';refeq=''" placeholder="Referencia">
    <br>
    <br>
    <label>Referencia Electrochips</label>
    <br>
    <input class="input" type="text" v-model="refeq" v-on:keyup.enter="f_refeq" v-on:click="subtipo='*',fam='';ref=''" placeholder="Referencia">
    <br>
    <label v-show="errShow">No se encontraron resultados</label>
    <half-circle-spinner v-show="spinner" class="circle1" :animation-duration="1000" :size="60" color="#4773aa"/>
    <br>
    <div v-show="tableShow" style="overflow:scroll; max-height: 40vh;">
      <table>
        <thead>
          <tr>
            <th scope="col">Tipo</th>
            <th scope="col">Subtipo</th>
            <th scope="col">Marca</th>
            <th scope="col">Fabricante</th>
            <th scope="col">Familia</th>
            <th scope="col">Ref Fabricante</th>
            <th scope="col">Ref Marca</th>
            <th scope="col">Ref electrochips</th>
            <th scope="col">PVP (sin IVA)</th>
            <th scope="col">Notas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in data" :key="key">
            <td data-label="Tipo">{{item.Tipo}}&nbsp;</td>
            <td data-label="Subtipo">{{item.subtipo}}&nbsp;</td>
            <td data-label="Marca">{{item.Marca}}&nbsp;</td>
            <td data-label="Fabricante">{{item.Fabricante}}&nbsp;</td>
            <td data-label="Familia">{{item.Familia}}&nbsp;</td>
            <td data-label="Ref Fabricante">{{item['Ref. Fabricante'] ? item['Ref. Fabricante'] : 'Varias Ref'}}&nbsp;</td>
            <td data-label="Ref Marca">{{item['Ref.Marca'] ? item['Ref.Marca'] : 'Varias Ref'}}&nbsp;</td>
            <td data-label="Ref electrochips">{{item.refequival}}&nbsp;</td>
            <td data-label="PVP">{{item.pvp == '' || item.pvp == 0 ? 'n/d' : item.pvp}} €&nbsp;</td>
            <td data-label="Notas">{{item.notas}}&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import API from '@/mixins/api-mixin.js'
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  data () {
    return {
      refeq: '',
      ref: '',
      fam: '',
      data: [],
      list: [],
      tipos: [],
      subtipos: [],
      errShow: false,
      img: '',
      tipo: '9',
      subtipo: '*',
      spinner: false,
      tableShow: false
    }
  },
  components: {
    HalfCircleSpinner
  },
  mixins: [API],
  mounted () {
    this.getData('/api/tipos/').then(function (response) {
      this.tipos = response
      this.getData('/api/subtipos/' + this.tipo).then(function (response) {
        this.subtipos = response
      }.bind(this))
    }.bind(this))
    this.load_famitags()
  },
  methods: {
    load_subtipos () {
      this.getData('/api/subtipos/' + this.tipo).then(function (response) {
        this.subtipos = response
      }.bind(this))
    },
    f_refeq () {
      this.load_table('/api/refeq/' + this.refeq)
    },
    f_ref () {
      this.load_table('/api/ref/' + this.ref)
    },
    f_fam () {
      let familia = this.fam.split('__').join('  ')
      this.load_table('/api/familia/' + familia)
    },
    load_famitags () {
      this.getData('/api/famitags/' + this.tipo + '/' + this.subtipo).then(function (response) {
        var arr = []
        response.forEach(function (element) {
          element.Nombre = element.Nombre.split('  ').join('__')
          arr.push(element.Nombre)
        })
        this.list = arr.slice()
      }.bind(this))
    },
    load_table (target) {
      this.data = []
      this.img = ''
      this.tableShow = false
      this.spinner = true
      this.getData(target + '/' + this.tipo + '/' + this.subtipo).then(function (response) {
        if (response[0]['Foto1'] != null) {
          this.img = response[0]['Foto1']
        } else {
          this.img = response[0]['Foto2']
        }
        this.data = response
        this.errShow = false
        this.spinner = false
        this.tableShow = true
      }.bind(this))
        .catch(function () {
          this.errShow = true
          this.img = ''
          this.spinner = false
        }.bind(this))
    }
  },
  computed: {
    getIMGRoute () {
      return store.state.PROTOCOL + '://' + store.state.IP + ':' + store.state.IMG_PORT + '/img/'
    }
  },
  watch: {
    fam () {
      // eslint-disable-next-line
      this.fam !== '' && this.fam !== null ? this.f_fam() : null
    },
    tipo () {
      this.fam = ''
      this.ref = ''
      this.img = ''
      this.data = []
      this.load_famitags()
      this.load_subtipos()
    },
    subtipo () {
      this.fam = ''
      this.ref = ''
      this.img = ''
      this.data = []
      this.load_famitags()
    }
  }
}
</script>
<style scoped>
.input {
  width:30vw;
}
.circle1 {
  margin-left: auto;
  margin-right: auto;
}
.logo {
  position:absolute;
  max-width:20vw;
  max-height: 20vh;
  top: 0;
  right: 0;
}
img {
  max-width: 100%;
  max-height: 100%;
}
.image {
    max-width:50vw;
    height: 300px;
    width: 500px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    left: 50vw;
}
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}
table caption {
  font-size: 1.5em;
  margin: .5em 0 .75em;
}
table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}
table th,
table td {
  padding: .625em;
  text-align: center;
}
table th {
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
}
@media screen and (max-width: 900px) {
  .input {
    width:50vw;
  }
  .image {
    max-width: 30vw;
    height: 250px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    left: 60vw;
  }
  table {
    border: 0;
  }
  table caption {
    font-size: 1.3em;
  }
  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }
  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
  }
  table td::before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }
  table td:last-child {
    border-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/screen/Buscador.vue